const appConfig = {
  "name": "appstore",
  "version": "1.0.0 ",
  "stage": "develop",
  "regions": [
    {
      "name": "us-east-1",
      "isPrimaryRegion": true,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config-dev.mit.edu",
      "amplify": {
        "userPoolId": "us-east-1_14cFcpuS8",
        "userPoolWebClientId": "7q43nh74cgirp523frrc9vefqo",
        "oauth": {
          "domain": "atlas-auth-dev.mit.edu",
          "scope": [
            "profile",
            "openid",
            "user/all",
            "digital-id/user"
          ],
          "redirectSignIn": "https://apps-dev.mit.edu",
          "redirectSignOut": "https://apps-dev.mit.edu/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api-dev.mit.edu",
        "paths": {
          "digital-id": "digital-id-v1"
        }
      }
    },
    {
      "name": "us-west-1",
      "isPrimaryRegion": false,
      "deployThisBuild": true,
      "regionDomain": "get.atlas-config-dev.mit.edu",
      "amplify": {
        "userPoolId": "us-west-1_zBZDEjiKC",
        "userPoolWebClientId": "66ghugjh5to5ohpbc1iinp1fuh",
        "oauth": {
          "domain": "atlas-auth-us-west-dev.mit.edu",
          "scope": [
            "profile",
            "openid",
            "user/all",
            "digital-id/user"
          ],
          "redirectSignIn": "http://localhost:9003",
          "redirectSignOut": "http://localhost:9003/logout",
          "responseType": "token",
          "options": {
            "AdvancedSecurityDataCollectionFlag": false
          }
        }
      },
      "signInProvider": "Touchstone",
      "api": {
        "domain": "api-us-west-dev.mit.edu",
        "paths": {
          "digital-id": "digital-id-v1"
        }
      }
    }
  ]
};
export default appConfig;